// @ts-nocheck
export const localeCodes =  [
  "en-US",
  "en",
  "fr-FR",
  "fr",
  "de-DE",
  "de",
  "es-ES",
  "es",
  "it-IT",
  "it",
  "nl-NL",
  "nl",
  "pt-PT",
  "pt"
]
export const localeLoaders = {
  "en-US": [],
  en: [],
  "fr-FR": [],
  fr: [],
  "de-DE": [],
  de: [],
  "es-ES": [],
  es: [],
  "it-IT": [],
  it: [],
  "nl-NL": [],
  nl: [],
  "pt-PT": [],
  pt: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ef6aa034" /* webpackChunkName: "config_i18n_46config_46ts_ef6aa034" */)
]
export const normalizedLocales = [
  {
    code: "en-US",
    language: "en-US"
  },
  {
    code: "en",
    language: "en"
  },
  {
    code: "fr-FR",
    language: "fr-FR"
  },
  {
    code: "fr",
    language: "fr"
  },
  {
    code: "de-DE",
    language: "de-DE"
  },
  {
    code: "de",
    language: "de"
  },
  {
    code: "es-ES",
    language: "es-ES"
  },
  {
    code: "es",
    language: "es"
  },
  {
    code: "it-IT",
    language: "it-IT"
  },
  {
    code: "it",
    language: "it"
  },
  {
    code: "nl-NL",
    language: "nl-NL"
  },
  {
    code: "nl",
    language: "nl"
  },
  {
    code: "pt-PT",
    language: "pt-PT"
  },
  {
    code: "pt",
    language: "pt"
  }
]
/** client **/

/** client-end **/